/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const c = (o, e) => {
  const t = { ...e };
  for (const n in o)
    o[n] !== void 0 && (t[n] = o[n]);
  return t;
};
export {
  c as applyDefaultProps
};
